import { UserAnalyticsService } from "@analytics/index";

import { CompanyType } from "@interfaces/company.type";

import { ICompanyTableControls } from "@store/filters/filter.types";

interface IUseAddIndustryToFilter {
  filtersObject: ICompanyTableControls;
  handleSetFilters: (filters: ICompanyTableControls["filters"]) => void;
  industries: string[];
  newIndustry: string;
}

export const addIndustryToFilter = ({
  filtersObject,
  handleSetFilters,
  industries,
  newIndustry,
}: IUseAddIndustryToFilter) => {
  const { filters } = filtersObject;
  const filterIndustries = filters.industries ?? [];
  const industryExists = filterIndustries.some((ind) => ind.toLowerCase() === newIndustry);

  if (industryExists) {
    handleSetFilters({
      industries: filterIndustries.filter((ind) => ind.toLowerCase() !== newIndustry),
    });
    return;
  }
  const industryName = industries.find((ind) => ind.toLowerCase() === newIndustry) ?? newIndustry;

  handleSetFilters({
    industries: [...filterIndustries, industryName],
  });
};

interface ISetFocusedCompany {
  companies: CompanyType[];
  setFocusedId: (id: string) => void;
}

export const handleRowFocus = ({ companies, setFocusedId }: ISetFocusedCompany) => {
  return (rowSelection: CompanyType, field: string) => {
    const focusedCompany = companies.find((company) => company.id === rowSelection.id);
    if (!focusedCompany || (field !== "name" && field !== "similarityScore")) return;

    UserAnalyticsService.trackCompanyRowClicked(
      focusedCompany.name,
      focusedCompany.patentSimilarityScore ?? 0,
      focusedCompany.numberMatchedPatents ?? "0",
      focusedCompany.estimatedNumEmployees,
      "smart-search",
    );

    setFocusedId(focusedCompany.id);
  };
};
